import { useEffect } from "react";

export default function redirect() {
    useEffect(() => {
        window.location.assign("https://www.youtube.com/watch?v=q-Y0bnx6Ndw");
    });
    return <></>;
}
